// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xx7Y","content":"styles_content__x8E-d"};